import React from "react";
import { CityForm } from "./Forms/CityForm";
import { useCreateCityMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

export const CreateCity = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name_ar: "",
      name_en: "",
    },
  });

  const { mutate: createCity, isPending } = useCreateCityMutation(setError);
  const { t } = useTranslation();

  const onSubmit = (data) => {
    createCity(data);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_CITY")}  />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <CityForm control={control} errors={errors} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_CITY")}
              </>
            ) : (
              t("CREATE_CITY")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};
